module.exports = __webpack_public_path__ + "static/media/icon-furs-01.8b098e48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-furs-01.svg
// module id = 984
// module chunks = 0